"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("../base");
const util_1 = require("../util");
class ERC721Module extends base_1.TectonicSDKModule {
    async balanceOf(tokenContractAddress, ownerAddress) {
        const erc721Contract = this.getContractByAddress(tokenContractAddress);
        return erc721Contract.balanceOf(ownerAddress);
    }
    async tokenOfOwnerByIndex(tokenContractAddress, ownerAddress, index) {
        const erc721Contract = this.getContractByAddress(tokenContractAddress);
        return erc721Contract.tokenOfOwnerByIndex(ownerAddress, index);
    }
    async tokenURI(tokenContractAddress, tokenId) {
        const erc721Contract = this.getContractByAddress(tokenContractAddress);
        return erc721Contract.tokenURI(tokenId);
    }
    async approve(tokenContractAddress, to, tokenId) {
        const erc721Contract = this.getContractByAddress(tokenContractAddress);
        return (0, util_1.wrapPlainTransaction)(erc721Contract.approve(to, tokenId));
    }
    async approveForAll(tokenContractAddress, toAddress) {
        const erc721Contract = this.getContractByAddress(tokenContractAddress);
        return (0, util_1.wrapPlainTransaction)(erc721Contract.setApprovalForAll(toAddress, true));
    }
    async isApproveForAll(tokenContractAddress, ownerAddress, toAddress) {
        const erc721Contract = this.getContractByAddress(tokenContractAddress);
        let result = false;
        try {
            result = await erc721Contract.isApprovedForAll(ownerAddress, toAddress);
        }
        catch (e) {
            //
        }
        return result;
    }
}
exports.default = ERC721Module;
//# sourceMappingURL=erc721.js.map